export interface FriendlyErrorOptions {
    genericMessage?: string;
    participantMessage?: string;
}

const DEFAULT_GENERIC_MESSAGE = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.';
const DEFAULT_PARTICIPANT_MESSAGE = 'Ihr Teilnehmerprofil konnte nicht geladen werden. Bitte versuchen Sie es später erneut.';

export function getFriendlyErrorMessage(error: unknown, options: FriendlyErrorOptions = {}): string {
    const genericMessage = options.genericMessage || DEFAULT_GENERIC_MESSAGE;
    const participantMessage = options.participantMessage || DEFAULT_PARTICIPANT_MESSAGE;

    if (!(error instanceof Error)) {
        return genericMessage;
    }

    const message = error.message.toLowerCase();

    if (message.includes('authentication') || message.includes('unauthorized') || message.includes('token') || message.includes('abgelaufen')) {
        return 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.';
    }

    if (message.includes('network') || message.includes('failed to fetch')) {
        return 'Keine Internetverbindung. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.';
    }

    if (message.includes('participant')) {
        return participantMessage;
    }

    return genericMessage;
}
